import './eloqua.less'

import InnerHTML from 'dangerously-set-html-content'
import React from 'react'
import {style} from 'util/style'
import {Theme} from 'views/theme'

const styles = style('eloqua')

export type EloquaType = {
	title?: string
	id?: string
	url?: string
}

export const Eloqua: React.FC<EloquaType> = ({title, id, url}) => {
	return (
		<div className={styles()}>
			<Theme.Container>
				{title && <Theme.H2 className={styles('title')}>{title}</Theme.H2>}
				<InnerHTML
					className={styles('formcontainer')}
					html={`
                        <iframe
                            id="form${id}"
                            class="eloqua-form"
                            allowfullscreen=""
                            frameborder="0"
                            marginheight="0px"
                            marginwidth="0px"
                            name="Test iframe height"
                            scrolling="no"
                            src="${url}";
                            style="border:0px #ffffff none;" width="100%"
                        ></iframe>
                        <script
                        src="https://images.communication.imec-int.com/Web/InteruniversitairMicroElectronicaCentrum/%7Bd9cbc1b6-0dd5-40bf-972a-fee75c86ed41%7D_embed.js"
                        type="application/javascript"
                        ></script>
                    `}
				/>
			</Theme.Container>
		</div>
	)
}
